// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 5621 ? "61d503f3" : chunkId) + "." + {"2191":"b54308e40f7d7fc4","4965":"89f441f725a82310","5621":"1eb5ac4772e54cd8","7192":"43f8ac415a582ef8"}[chunkId] + ".js";
};